import { Button, Heading, Text } from "@rshbintech.dboul/core-ui";
import { MainpageWarning as MainpageWarningImage } from "@rshbintech.dboul/images";
import { useAppTranslation } from "../../../hooks";
import styles from "./styles.scss";

const handleResetError = () => {
  window.location.reload();
};

export const ErrorPage = () => {
  const { translate } = useAppTranslation("LAYOUT");

  return (
    <div className={styles.background}>
      <div className={styles.main}>
        <div className={styles["main-image"]}>
          <MainpageWarningImage />
        </div>
        <div className={styles.text}>
          <Heading level={2} className={styles.heading}>
            {translate("CONTENT.ERROR_PAGE_DICTIONARY.ERROR_TEXT")}
          </Heading>
          <div className={styles.description}>
            <p>
              <Text size="medium">
                {translate("CONTENT.ERROR_PAGE_DICTIONARY.DESCRIPTION_TEXT")}
              </Text>
            </p>
            <p>
              <Text size="medium">
                {translate("CONTENT.ERROR_PAGE_DICTIONARY.SUGGESTION_TEXT")}
              </Text>
            </p>
          </div>
          <Button
            onClick={handleResetError}
            className={styles.button}
            size="medium"
            type="primary"
            htmlType="button"
          >
            {translate("CONTENT.ERROR_PAGE_DICTIONARY.BUTTON_TEXT")}
          </Button>
        </div>
      </div>
    </div>
  );
};
